module.exports = __webpack_public_path__ + "./fonts/GTWalsheimPro-SemiBold.ttf";